import { css } from 'linaria';

export const alertIcon = css`
  width: 20px;
  height: 20px;

  fill: var(--contol-invert, currentColor);
`;
